import { Inject, Injectable } from '@angular/core';
import { Tip } from '@shared/models';
import { GenericCrudService, getCrudName } from '@shared/modules/crud';
import { DefaultRessourceStore } from '@shared/services/stores/default-ressource-store.service';

@Injectable()
export class TipStore extends DefaultRessourceStore<Tip> {
    constructor(@Inject(getCrudName(Tip)) protected crudService: GenericCrudService<Tip>) { super(crudService) }
}